import { ORDERS_SERVICE } from "@/services/orders.service.js";
import router from '@/router/index';

const state = { listOutput: {}, processTask: false };

const actions = {
    getList({ dispatch, commit }, inputGetOrders) {
        dispatch('alert/clear', null, { root: true });
        commit('listRequest');
        
        ORDERS_SERVICE.list(inputGetOrders)
            .then(
                output => {
                    commit('listSuccess', output);
                },
                error => {
                    commit('listFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    remove({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('removeRequest');

        ORDERS_SERVICE.remove(id)
        .then(
            output => {
                commit('removeSuccess', output);
            },
            error => {
                commit('removeFailure', error);
                dispatch('alert/error', error, { root: true });
            }
        );
    },
    markPaid({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('updateStatusRequest');

        ORDERS_SERVICE.updateStatus(id, "Paid")
        .then(
            output => {
                commit('updateStatusSuccess', output);
            },
            error => {
                commit('updateStatusFailure', error);
                dispatch('alert/error', error, { root: true });
            }
        );
    },
};

const mutations = {
    /* List */
    listRequest(state) {
        //
    },
    listSuccess(state, output) {
        state.listOutput = output;
    },
    listFailure(state) {
        state.listOutput = [];
    },
    /* Remove */
    removeRequest(state) {
        state.processTask = null;
    },
    removeSuccess(state) {
        state.processTask = true;
    },
    removeFailure(state) {
        state.processTask = false;
    },
    /* Update status */
    updateStatusRequest(state) {
        state.processTask = null;
    },
    updateStatusSuccess(state) {
        state.processTask = true;
    },
    updateStatusFailure(state) {
        state.processTask = false;
    },
};

export const orders = {
    namespaced: true,
    state,
    actions,
    mutations
};